import { databaseRef } from 'config'

import { action } from '../../dispatchAction'
import { USER_ACTION_TYPES } from '../types'

export const updateParentInstructComplete = (
  onSuccess: () => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async (dispatch, getState) => {
  const { uid } = getState().user.auth
  const { parental_instructions_complete } = getState().user.data

  if (parental_instructions_complete) {
    return onSuccess()
  }

  try {
    await databaseRef
      .child('users')
      .child(uid)
      .child('parental_instructions_complete')
      .set(true)

    dispatch(action(USER_ACTION_TYPES.update_parental_instructions_complete))
    onSuccess()
  } catch (err) {
    errorCallback(err)
  }
}



// WEBPACK FOOTER //
// ./src/store/user/actions/updateParentInstructComplete.action.ts